const SITE_URL = 'https://www.thinkincode.co.za'
const SITE_LABEL = 'www.thinkincode.co.za'
const BRAND_LABEL = 'thinkinCode(☁️);'

/**
 * Shared ThinkinCode attribution footer for app shells.
 * @param {'light' | 'dark'} variant
 */
export default function ThinkinCodeFooter({ className = '', variant = 'light' }) {
  const muted = variant === 'dark' ? 'text-white/55' : 'text-slate-500'
  const infoLink = variant === 'dark' ? 'font-medium text-teal-300 hover:underline' : 'font-medium text-teal-700 hover:underline'
  const brandLink =
    variant === 'dark' ? 'font-semibold text-white hover:underline' : 'font-semibold text-slate-800 hover:underline'

  return (
    <footer
      className={`mt-2 flex flex-col items-center gap-1.5 px-2 py-3 text-center text-xs ${muted} sm:flex-row sm:justify-center sm:gap-4 ${className}`}
    >
      <div className="flex flex-wrap items-center justify-center gap-1">
        <span>For more info visit</span>
        <a href={SITE_URL} target="_blank" rel="noopener noreferrer" className={infoLink}>
          {SITE_LABEL}
        </a>
      </div>
      <div className="flex items-center gap-1">
        <span>Powered by</span>
        <a href={SITE_URL} target="_blank" rel="noopener noreferrer" className={brandLink}>
          {BRAND_LABEL}
        </a>
      </div>
    </footer>
  )
}

export const THINKINCODE_SITE_URL = SITE_URL
export const THINKINCODE_SITE_LABEL = SITE_LABEL
export const THINKINCODE_BRAND_LABEL_PLAIN = 'thinkinCode'
